import { v4 as uuidv4 } from "uuid";
import { OOOrderType } from "./oo-order-type";

export class OOOrderTypeDeliveryZone {
	key: string = uuidv4();
	venueKey: number;
	orderTypeKey: number;
	vertices: string;
	name: string;
	deliveryFee: number;
	menuItemKey?: number;
	points?: google.maps.LatLngLiteral[];
	strokeColor?: string;
	fillColor?: string;
	created: Date;
	modified: Date;

	OOOrderType: OOOrderType;
	polygonOptions?;

	public constructor(init?: Partial<OOOrderTypeDeliveryZone>) {
		Object.assign(this, init);
		if (this.vertices) {
			this.points = JSON.parse(this.vertices);
		}
		this.polygonOptions = {
			strokeColor: this.strokeColor,
			fillColor: this.fillColor,
		};
	}
}
